import { useState, useEffect } from 'react';
import { selfLearnerService } from 'PlatForms/SelfLMS/Services/Courses/CourseService';

const useEnrolledCourses = () => {
  const [enrollments, setEnrollments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 6,
    totalCount: 0,
    totalPages: 0,
    orderByLatest: true
  });

  const fetchEnrolledCourses = async (page = 1, pageSize = pagination.pageSize) => {
    try {
      setLoading(true);
      setError(null);

      const data = await selfLearnerService.getEnrolledCourses({
        pageNumber: page,
        pageSize: pageSize,
        orderByLatest: pagination.orderByLatest
      });
      
      console.log("enrolled course data", data);

      setEnrollments(data.items || []);
      setPagination(prev => ({
        ...prev,
        currentPage: page,
        pageSize: pageSize,
        totalCount: data.totalCount || 0,
        totalPages: data.totalPages || 0
      }));
    } catch (err) {
      console.error('Error fetching enrolled courses:', err);
      setError(err.message || 'Failed to fetch enrolled courses');
      setEnrollments([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEnrolledCourses(pagination.currentPage, pagination.pageSize);
  }, []);

  const handlePageChange = (page) => {
    fetchEnrolledCourses(page, pagination.pageSize);
  };

  const handlePageSizeChange = (pageSize) => {
    // When page size changes, reset to page 1
    fetchEnrolledCourses(1, pageSize);
  };

  return {
    enrollments,
    loading,
    error,
    pagination,
    handlePageChange,
    handlePageSizeChange,  // Make sure this is exported
    refetch: () => fetchEnrolledCourses(pagination.currentPage, pagination.pageSize)
  };
};

export default useEnrolledCourses;